import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
    mainWrapper: {
        position: "relative",
    },
}));
